<template>
  <vs-popup
    :title="getTitle()"
    @onClose="handleOnClose"
    :active.sync="showThisPopup"
    class="reject-guest-popup"
  >
    <div v-if="guestListItem">
      <vs-row>
    <p :class="`mb-1 ${arrivedCount == guestListItem.guestCount ? 'w-full text-center text-xl' : '' }` " style="font-weight:600">
        {{getArrivedCountTitle}}
      </p>
      </vs-row>
  
      <vs-row vs-w="12" class="mt-4" vs-justify="center" v-if="arrivedCount == guestListItem.guestCount && !viewArrivals && !isEditingArrival">
      <vs-button
        class="mr-2"
        @click="showArrivals"
        >
        View arrivals
        </vs-button>

    </vs-row>
      <div v-if="arrivedCount != guestListItem.guestCount || isEditingArrival" >
        <p class="mb-1 mt-2 text-sm text-gray-500">
       {{isEditingArrival ? 'Edit guests arrived' : 'New guests arrived'}} 
      </p>

      <vs-input
          class="inputx"
          v-model="numberOfArrivedGuest"
          type="number"
          
          @change="() => {if(isEditingArrival && numberOfArrivedGuest > guestsLeft + editingArrival.numPeopleArrived ){
                          numberOfArrivedGuest = guestsLeft + editingArrival.numPeopleArrived 
                          }            
                          if(numberOfArrivedGuest > guestsLeft && !isEditingArrival) {
                          numberOfArrivedGuest = guestsLeft
                            } else if (numberOfArrivedGuest<0){
                            numberOfArrivedGuest = 0
                            } 
                          }"
        />

  <p class="mb-1 mt-2 text-sm text-gray-500">
       {{isEditingArrival ? 'Edit note' : 'Note'}} 
      </p>
              <textarea
        v-model="note"
        type="text"
        class="
          mb-2
          rounded-lg
          w-full
          h-16
          focus:outline-none
          border border-gray-200
          focus:ring focus:border-blue-300
          p-2
        "
      >
      </textarea>
      </div>
    </div>
    

    <vs-row vs-w="12" vs-justify="flex-end" v-if=" guestListItem &&  arrivedCount != guestListItem.guestCount || isEditingArrival">
      <vs-button
        class="mr-2"
        color="success"
        :disabled="!validForm"
        @click="handleSaveClick"
        >{{isEditingArrival ? "Update" : "Add arrival"}}</vs-button
      >
      <vs-button type="border" color="primary" @click="handleOnClose"
        >Cancel</vs-button
      >
    </vs-row>



     
      <div v-if="viewArrivals | arrivedCount != guestListItem.guestCount " >
        <p class="mb-1 mt-2 text-lg text-gray-500">
       Arrivals
      </p>
      <vs-row v-for="(arrival, index) in guestListItem.arrivals" :key="index" class="flex gap-2 mt-2">
           <vs-button type="border" class="text-xs py-1" @click="editArrival(arrival)"
        >Edit</vs-button
      >
          <p>{{getArrivalTime(arrival.registrationTime)}}: Guests: {{arrival.numPeopleArrived}}, Note: {{arrival.note}}</p>
  
      </vs-row>
   <vs-button type="border" color="primary" class="mt-2" style="float:right" v-if="arrivedCount == guestListItem.guestCount" @click="handleOnClose"
        >Cancel</vs-button
      >
    </div>
    

  </vs-popup>
</template>

<script>
import moment from 'moment'
export default {
  
  components: {},
  data() {
    return {
      numberOfArrivedGuest: 0,
      note: "",
      guestListItem: null,
      showThisPopup: false,
      viewArrivals: false,
      isEditingArrival: false,
      editingArrival: null
    };
  },
  mounted() {
    this.viewArrivals = false
   
  },
  computed: {
    validForm() {
      return this.numberOfArrivedGuest > 0 || this.isEditingArrival;
    },

    arrivedCount(){
      if(this.guestListItem){
      if(this.guestListItem.arrivals.length == 0) {return 0}
      var arrived = 0
      this.guestListItem.arrivals.forEach(arrival => {
          arrived += arrival.numPeopleArrived
      });
      return arrived
     
      }
      
    },

    getArrivedCountTitle(){
    if(this.isEditingArrival){return `Editning arival at ${ this.getArrivalTime(this.editingArrival.registrationTime)}`}
     return this.arrivedCount == this.guestListItem.guestCount ? "All guests has arrived" :
                            `${this.arrivedCount} / ${this.guestListItem.guestCount} guests currently arrived`
          
    },

    guestsLeft(){
      if(this.guestListItem){  
        return this.guestListItem.guestCount - this.arrivedCount
      }
    },

  },
  methods: {
    show(guestListItem) {
      this.guestListItem = guestListItem;
      console.log("DAD,",guestListItem)
      this.showThisPopup = true;
      this.isEditingArrival = false
      this.editingArrival = null
    },
    getTitle() {
      return this.guestListItem .fullName? `Partial arrival for ${this.guestListItem.fullName}` : 'Partial arrival';
    },

    
    handleSaveClick() {
      
      let arrival = {note: this.note, numberOfGuests: this.numberOfArrivedGuest}
      if(this.editingArrival){
       arrival = {note: this.note, numberOfGuests: this.numberOfArrivedGuest, arrivalId: this.editingArrival.registrationId}
      }
      this.$emit('update-guest-arrival-count', { guestListItem: this.guestListItem, arrival: arrival});
      this.handleOnClose();
    },
    handleOnClose() {
      this.numberOfArrivedGuest=0
      this.note = '';
      this.isEditingArrival = false
      this.editingArrival = null
      this.showThisPopup = false;
      this.viewArrivals = false
    },
    showArrivals(){
    this.viewArrivals = true
  },
    editArrival(arrival){
      this.viewArrivals = false
      this.isEditingArrival = true
      this.editingArrival = arrival
      this.note = arrival.note
      this.numberOfArrivedGuest = arrival.numPeopleArrived
    },

    getArrivalTime(time){
        return moment(time).format("HH:mm")
    }

  },
  
};
</script>

<style lang="scss" scoped>
.reject-guest-popup::v-deep {
  z-index: 54000;
  .vs-popup {
    width: 768px;
  }
}
</style>
